import { Application, Organisation } from '@/types';

export class ApplicationMutator {
  public static toTabular(application: Application): any {
    return {
      application: {
        value: application.name,
        property: 'application.name',
      },
      organisations: {
        value: application.organisations ? application.organisations.map((o: Organisation)  => o.name).join(', ') : null,
        property: 'organisations.name',
      },
      type: {
        value: application.type,
        property: 'type',
      },
      src: {
        value: application.src,
        property: 'src',
      },
      id: application.id,
    };
  }
}
